module.exports = __webpack_public_path__ + "img/Download_On_Play_Store_Badge.63354186.png";